import { __decorate } from "tslib";
import axios from 'axios';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let User = class User extends VuexModule {
    constructor() {
        super(...arguments);
        this.user = null;
    }
    get authenticationHeader() {
        return async (myThis) => {
            await myThis.dispatch('authentication/fetchAccessToken', {}, { root: 'true' });
            return myThis.rootGetters['authentication/axiosHeader'];
        };
    }
    async postUser(user) {
        const header = await this.getters.authenticationHeader(this);
        let returnedUser = (await axios.post(`${process.env.VUE_APP_sw5eapiurl}/api/user`, { username: user.username }, header)).data;
        return { user: returnedUser };
    }
    async getUser() {
        const header = await this.getters.authenticationHeader(this);
        let returnedUser = (await axios.get(`${process.env.VUE_APP_sw5eapiurl}/api/user`, header)).data;
        return { user: returnedUser };
    }
};
__decorate([
    MutationAction({ mutate: ['user'] })
], User.prototype, "postUser", null);
__decorate([
    MutationAction({ mutate: ['user'] })
], User.prototype, "getUser", null);
User = __decorate([
    Module({ namespaced: true, name: 'user' })
], User);
export default User;
